import { Outlet, useNavigate } from "react-router-dom";

export default function OrderMain(props) {
  return (
    <>
      <Outlet />
    </>
  );
}
